import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { expandShortSharePath } from '@/utils/acquisitionAttribution';

/**
 * Client side of the /r/ and /ref/ short links. A full page load is already
 * redirected by api/ssr.ts; this covers in-app navigation and sends it to the
 * same destination with the same UTMs. Links without a safe destination keep
 * the old fallback to "/". /r/app leaves the site for the App Store.
 */
export function ShortShareRedirect() {
  const location = useLocation();
  const destination = expandShortSharePath(`${location.pathname}${location.search}`);
  const isExternal = destination?.startsWith('https://') ?? false;

  useEffect(() => {
    if (isExternal && destination) window.location.replace(destination);
  }, [destination, isExternal]);

  if (isExternal) return null;
  return <Navigate to={destination ?? '/'} replace />;
}
